import Logo from '@/assets/images/3p-logo.png';
import { useSizes } from '@/utility/responsive.ts';
import React from 'react';

type Props = {
	onLeave: () => void;
	onToggleCamera: () => void;
	userInfos?: {
		studentName: string;
		studentAvatar: string;
		coachName: string;
		coachAvatar: string;
		coachSubject: string;
	} | null;
};

export default function MeetCameraHeader({ onLeave, onToggleCamera, userInfos }: Props) {
	const { isDesktop, isMobile } = useSizes();

	return (
		<div className={'meet-camera-header'}>
			<div className={'meet-camera-header-logo'}>
				<a>
					<img
						src={Logo}
						alt="Doping Hafıza 3P"
					/>
				</a>
			</div>
			{isMobile && (
				<>
					<div className={'meet-camera-header-camera-action-buttons'}>
						<div
							className={'rotate-cam-btn'}
							onClick={onToggleCamera}>
							<i className="icons-rotate-cam" />
						</div>
					</div>
					<div className={'meet-camera-header-user-info'}>{userInfos?.studentName}</div>
				</>
			)}
			<div className={'meet-camera-header-action-buttons'}>
				<div
					className="meet-camera-header-action-buttons-end-call"
					onClick={onLeave}>
					{isDesktop && 'Görüşmeyi Sonlandır'}
					{isMobile && <i className="icons-end-call" />}
				</div>
			</div>
		</div>
	);
}
